import cardContentClasses from "@mui/material/CardContent/cardContentClasses";
import { cardHorizontalContentClasses } from "../CardHorizontalContent/CardHorizontalContent.styled";
export const MuiCardContentTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                hasPixelTheme: "true",
                display: "flex",
                flexDirection: "column",
                gap: dt.space.stack.medium,
                padding: `${dt.space.stack.xSmall} ${dt.space.stack.small}`,
                [`.${cardHorizontalContentClasses.root} &`]: {
                    padding: 0,
                },
                ":empty": {
                    display: "none",
                },
                [`& + .${cardContentClasses.root}`]: {
                    paddingTop: 0,
                },
            },
        },
    };
};
